var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1763 10.8611C13.8917 11.1474 13.732 11.5346 13.732 11.9382C13.732 12.3418 13.8917 12.729 14.1763 13.0153L19.5846 18.5L14.1763 23.9083C13.8917 24.1946 13.732 24.5818 13.732 24.9854C13.732 25.389 13.8917 25.7762 14.1763 26.0625C14.3183 26.2057 14.4873 26.3193 14.6735 26.3969C14.8596 26.4745 15.0593 26.5144 15.261 26.5144C15.4627 26.5144 15.6624 26.4745 15.8486 26.3969C16.0347 26.3193 16.2037 26.2057 16.3457 26.0625L22.8235 19.5847C22.9667 19.4427 23.0804 19.2737 23.1579 19.0875C23.2355 18.9014 23.2754 18.7017 23.2754 18.5C23.2754 18.2983 23.2355 18.0986 23.1579 17.9124C23.0804 17.7263 22.9667 17.5573 22.8235 17.4153L16.3457 10.8611C16.2037 10.7179 16.0347 10.6043 15.8486 10.5267C15.6624 10.4491 15.4627 10.4092 15.261 10.4092C15.0593 10.4092 14.8596 10.4491 14.6735 10.5267C14.4873 10.6043 14.3183 10.7179 14.1763 10.8611Z",
    fill: "#3BB77E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ec1cbc564e14345e12f11a78c11e0536.svg";
export { ForwardRef as ReactComponent };